import React from 'react';
import { useParams } from 'react-router-dom';

import { ContainerHeader } from '~components';
import { faUserNurse } from '~components/icon';

// TAV-2635 placeholder — replaced by the per-client care plan view in a later Care Plans story.
const CarePlanView: React.FC = () => {
  const { client_id } = useParams();

  return (
    <div className="p-3">
      <ContainerHeader icon={faUserNurse} dataCy="care-plan-view-header">
        Care Plan
      </ContainerHeader>
      <p className="ps-3 pt-2 text-muted">Client {client_id}</p>
    </div>
  );
};

export default CarePlanView;
